module.exports = __webpack_public_path__ + "img/Skills.df28f084.svg";